import { ILocalStorage } from '@utils';
import { postAbRouter } from '@/api/abtest';

export function divideAbRouter(params) {
  return new Promise((resolve, reject) => {
    postAbRouter(params).then(res => {
      if (res.data) {
        const abInfo = {
          abActivityId: res.data.abActivityId,
          ab_uuid: params.sessionId,
          lastUrl: res.data.jumpUrl,
          bucketName: params.whiteBucketName ? params.whiteBucketName : res.data.bucketName
        };
        ILocalStorage('abID', res.data.abActivityId);

        let locationUrl = location.href;
        let oldUrl = res.data.jumpUrl;
        let obj = {};

        let ownConfigProperty = handleQuery(oldUrl);
        let locationProperty = handleQuery(locationUrl);

        delete locationProperty.itemid;

        if (locationProperty.at_id) {
          delete locationProperty.at_id;
        }

        obj = Object.assign({}, { itemid: ownConfigProperty.itemid }, locationProperty);

        if (obj.itemid) {
          abInfo.itemid = obj.itemid;
        }

        ILocalStorage(res.data.abActivityId, JSON.stringify(abInfo));

        let queryStr = '';
        for (let key in obj) {
          queryStr += `${key}=${obj[key]}&`;
        }

        let url = `${oldUrl.split('?')[0]}?${queryStr}abFlag=1`;
        // let url = `http://test.igetcool.com:8888/mall/course?${queryStr}abFlag=1&igc_from=${params.igc_from}`;
        location.href = url;
      }
      resolve();
    }).catch(err => {
      resolve(err);
    });
  });
}

function handleQuery(oldUrl) {
  let query = oldUrl.split('?')[1].split('&');
  let obj = {};
  for (let i = 0; i < query.length; i++) {
    obj[query[i].split('=')[0]] = query[i].split('=')[1];
  }

  return obj;
}